<template>
    <v-text-field v-model="modelValue" v-bind="{ ...attrs_input_common, ...$attrs }" @input="emit" @keydown.enter="$emit('search')" filled class="rounded-0">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </v-text-field>
</template>

<script>
import { attrs_input_common } from "@/assets/variables";

export default {
    props: {
        value: { type: String, default: null },
    },
    data: () => ({
        modelValue: null,
        attrs_input_common,
    }),
    methods: {
        sync() {
            this.modelValue = this.value;
        },
        emit() {
            this.$emit("input", this.modelValue);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped></style>
